// extracted by mini-css-extract-plugin
export default {"container":"panoramaSlider_container__gkNfv"};